import { CERelationshipAttributePermissionRuleAttributesBase } from './ce-relationship-attribute-permission-rule-attributes-base'


export class CERelationshipAttributePermissionRuleAttributes extends CERelationshipAttributePermissionRuleAttributesBase {

}